/**
 * The motifs the mission wizard offers, in the order the step lists them.
 * Only the label is shown: `type` is what the api stores, and must not change.
 */
export const MISSION_MOTIFS = [
    {
        type: "3",
        key: "replacement",
        defaultTitle: "Remplacement d'un ou plusieurs salariés absents",
        modal: "cM_remplacement",
    },
    {
        type: "1",
        key: "activityIncrease",
        defaultTitle: "Accroissement temporaire d'activité",
        modal: "cM_accroissement",
    },
    {
        type: "2",
        key: "awaitingRecruitment",
        defaultTitle: "En attente de recrutement",
        modal: "cM_attRecrutement",
    },
    {
        type: "4",
        key: "customaryContract",
        defaultTitle: "Contrat temporaire d'usage",
        modal: "cM_temporaire",
    },
    {
        type: "5",
        key: "seasonal",
        defaultTitle: "Emploi à caractère saisonnier",
        modal: "cM_saisonnier",
    },
];

export const getMissionMotifLabel = (language, motif) =>
    language.getValue(`missionCreation.motif.types.${motif.key}`, motif.defaultTitle);

export const getMissionMotifTitle = (type, language) => {
    const motif = MISSION_MOTIFS.find((item) => item.type === String(type));
    return motif ? getMissionMotifLabel(language, motif) : "";
};

/** What the chosen motif adds: who is replaced, since when, or the reason itself. */
export const getMissionMotifDetail = (motif, formatDate) =>
    [
        [motif?.prenom, motif?.name].filter(Boolean).join(" "),
        motif?.poste,
        motif?.date && formatDate ? formatDate(motif.date) : "",
        motif?.message,
    ]
        .filter((part) => typeof part === "string" && part.trim() !== "")
        .join(" — ");
